export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/ob-step-11.png?eb047bdf912107b40599bfe8bbddf7ab";